exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addSample[data-v-5c7ec2b7]{position:relative;top:20px;left:17px}.addSample .ivu-form-item-content[data-v-5c7ec2b7]{width:200px}.delete[data-v-5c7ec2b7]{width:20px}.addSampleButton[data-v-5c7ec2b7]{position:relative;left:370px;margin-bottom:20px}.ivu-col-span-7[data-v-5c7ec2b7]{padding-left:19px}.inputWidth[data-v-5c7ec2b7]{width:200px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c7ec2b7","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--1-1!./src/components/case/caseManager/addCase/CaseInfo.vue
// module id = 0vM+
// module chunks = 2